import { CSSProperties } from "react";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { PopoutButton } from "@/Common/Components/Buttons/PopoutButton";

import RotateClockwise from "@/Globals/_images/arrow-clockwise.svg";
import RotateCounterClockwise from "@/Globals/_images/arrow-counterclockwise.svg";
import TrashIcon from "@/Globals/_images/trash3.svg";

interface PdfViewerPageToolbarProps {
    onRotate: (newOrientation: number) => void;
    onTrashed: () => void;
    pageOrientation: number;
    isDeletable?: boolean;
    style?: CSSProperties;
    onOpenPdfPreview?: () => void;
}

class PdfViewerPageToolbar extends BaseReactComponent<PdfViewerPageToolbarProps> {
    public render(): JSX.Element {
        return (
            <div className="pdf-viewer-page-toolbar toolbar" style={this.props.style} onClick={e => e.stopPropagation()}>
                {this.props.isDeletable &&
                    (<button className="btn-danger" onClick={() => this.props.onTrashed()}><TrashIcon /></button>)
                }
                <button onClick={() => this.returnNormalizedOrientation(-90)}>
                    <RotateCounterClockwise />
                </button>
                <button onClick={() => this.returnNormalizedOrientation(90)}>
                    <RotateClockwise />
                </button>
                <PopoutButton
                    onPopoutClick={() => this.props.onOpenPdfPreview?.()}
                />
            </div>
        );
    }

    private returnNormalizedOrientation(angleDifference: number): void {
        let newOrientation = this.props.pageOrientation + angleDifference;

        if (newOrientation < 0)
            newOrientation = 270;
        else if (newOrientation > 270)
            newOrientation = 0;

        this.props.onRotate(newOrientation);
    }
}

export { PdfViewerPageToolbar };
